import React from "react";
import {  StyledH2 } from "@aureskonnect/react-ui";
import { useTranslation } from "react-i18next";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import classnames from "classnames";
import { DynamicTable } from "@maherunlocker/custom-react-table";
import { capitalize } from "@helpers/general";
import { resetStore } from "@pages/Applications/DeviceAssociateModal/store";
import { useSnapshot } from "valtio";
import { store } from "@components/VerticalLayout/store";

import { setIsModeOfInformation } from "./store";
import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";


export default function HistoryModal({
    setIsModalOpened,
    isModalOpened,
    ids,
    rowData,
    setData,
}: any) {
    const { t } = useTranslation();
    const i18nextLng = localStorage.getItem("i18nextLng") || "fr";
    const { userID, franchiseID } = useSnapshot(store);
    const [dataIsUpdated, setDataIsUpdated] = React.useState<boolean | number>(
        false
    );
    const [filterActive, setLocalFilterActive] = React.useState<boolean>(false);
    const ActionColumn = (e: any) => {
        return e.selectedRow.subRows === undefined ? <div></div> : null;
    };

    const [arrayIds, setArrayIds] = React.useState<any[]>([]);
    const url = `${
        process.env.REACT_APP_API_V2_URL
    }/settings/general/mode_of_Information/history?userId=${userID}&franchiseId=${franchiseID}&Informations=${arrayIds
        .map((el: any) => JSON.stringify(el))
        .join()}`;

    const getArrayOfIds = () => {
        let array1 = [...arrayIds];
        let existArray = [...arrayIds];

        for (let element of ids) {
            if (element[t("Shop")] !== "" && element[t("Shop")] === undefined) {
                if (
                    existArray.indexOf(`${element.shopId}${element.Id}`) === -1
                ) {
                    array1.push({ [element.shopId]: element.Id });
                    existArray.push(`${element.shopId}${element.Id}`);
                }
            }
        }
        setArrayIds(array1);
    };
    React.useEffect(() => {
        getArrayOfIds();
        // eslint-disable-next-line
    }, []);

    return (
        <React.Fragment>
            <Modal
                centered
                backdrop="static"
                fade={false}
                scrollable
                className="modal-wrapper__clz"
                isOpen={isModalOpened}
            >
                <ModalHeader
                    toggle={() => {
                        setIsModalOpened!(!isModalOpened);
                        resetStore();
                        setIsModeOfInformation(false);
                        setData(true);
                    }}
                >
                    <StyledH2 className="text-uppercase mdi_txt_HStitleHistory">
                        {capitalize(t("History"))}
                    </StyledH2>
                </ModalHeader>

                <ModalBody>
                    <div
                        className={`${classnames(" ", {
                            "not-allowed-icon__clz": ids.length > 1,
                        })}`}
                    >
                        <div className="title__clz dropdown-item pl-1 pointer__clz">
                            {t("Mode of information")} :{" "}
                            {ids.length > 1
                                ? null
                                : rowData[t("Mode of information")]}
                        </div>
                    </div>

                    <DynamicTable
                        url={url}
                        requestHeader={{ "Accept-Language": i18nextLng }}
                        canResize
                        actionColumn={ActionColumn}
                        showGlobalFilter
                        showFilter
                        setLocalFilterActive={setLocalFilterActive}
                        filterActive={filterActive}
                        setDataIsUpdated={setDataIsUpdated}
                        dataIsUpdated={dataIsUpdated}
                        elevationTable={1}
                        minHeight="500px"
                        maxHeight="500px"
                        name="historyModeOfInformation"
                    />
                </ModalBody>
                <ModalFooter className="border-top-0">
                    <CustomMainColorButton
                        rounded
                        variant="primary"
                        className="mdi_btn_HSclose"
                        onClick={() => {
                            setIsModalOpened(!isModalOpened);
                            setData(true);
                        }}
                    >
                        {t("Close")}
                    </CustomMainColorButton>
                </ModalFooter>
            </Modal>
        </React.Fragment>
    );
}
